import { CheerioAPI } from 'cheerio';

export const listToSavedForm = ($: CheerioAPI, element, level = 0) => {
    const indent = '  '.repeat(level);
    let itemsCount = 0;

    $(element).children('li').each((_, li) => {
        itemsCount++;
        const nestedUl = $(li).children('ol');
        const textContent = $(li).contents().not('ol').text().trim();

        if (nestedUl.length) {
            listToSavedForm($, nestedUl, level + 1);
            nestedUl.remove();
        }

        const startChar = $(li).attr('data-list') === 'bullet' ? '*' : `${itemsCount}.`;
        $(li).replaceWith(`${indent}${startChar} ${textContent}\n${nestedUl.length ? nestedUl.html() : ''}`);
    });

    $(element).replaceWith($(element).html());
};

export const listToEditorForm = (lines: string[]) => {
    const html = ['<ol>'];
    const stack = [{ indent: 0, text: '' }];

    lines.forEach(line => {
        const indentLevel = line.match(/^\s*/)[0].length;
        const text = line.trim().replace(/^(\*|\d+\.)\s*/, '') || '&nbsp;';
        const ordered = /^\d+\./.test(line.trim());

        while ((stack[stack.length - 1].indent > indentLevel) && (stack.length > 1)) {
            html.push('</li></ol>');
            stack.pop();
        }

        if ((indentLevel === stack[stack.length - 1].indent) && (stack.length > 1)) {
            html.push('</li>');
        }
        else if (indentLevel > stack[stack.length - 1].indent) {
            html.push('<ol>');
        }

        // eslint-disable-next-line max-len
        html.push(`<li data-list=${ordered ? '"ordered"' : '"bullet"'}><span class="ql-ui"></span>${text}`);
        stack.push({ indent: indentLevel, text });
    });

    while ((stack.pop()).indent > 0) {
        html.push('</li></ol>');
    };

    html.push('</li></ol>');
    const listMarkdown = html.join('');

    return listMarkdown;
};
